export default __webpack_public_path__ + "static/media/Screenshot_7.9bb1cc33.png";